import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataSourcesEnum } from 'src/app/enums/DataSourcesEnum';
import { ElectionStatusEnum } from 'src/app/enums/ElectionStatusEnum';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { ISelectPage } from 'src/app/interfaces/ISelectPage';
import { ElectionService } from 'src/app/services/election.service';

@Component({
  selector: 'app-page-ha-summary',
  templateUrl: './page-ha-summary.component.html',
  styleUrls: ['./page-ha-summary.component.scss']
})
export class PageHaSummaryComponent implements OnInit, AfterViewInit, OnDestroy {

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();
  public electionStatusString = '';
  public disclaimer = '';
  public leadingByDistrictTitle = '';
  public bodyHeight: string = '' + (window.innerHeight - 110) + 'px';

  public cols = 2;
  public rowHeight = 90;
  public pageTitle = '';
  public headingTitle = 'House of Assembly Results';
  public lastUpdate: Date = new Date();
  public seatsTitle = '';
  public isMobile = false;
  public isFinal = false;

  constructor(
    public electionService: ElectionService,
    private deviceService: DeviceDetectorService
  ) {
    this.electionService.dataLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(dataLoaded => {
      if (this.isDataLoaded(dataLoaded.electionDate)) {
        this.loadPage(this.electionService.selectedPage);
      }
    });
    this.electionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(page => {
      this.loadPage(page);
    });
  }

  ngOnInit() {
    this.checkResize();
    fromEvent(window, 'resize').subscribe(e => {
      this.checkResize();
    });
  }

  ngAfterViewInit(): void {
    if (this.isDataLoaded(this.electionService.selectedPage.electionDateString ?? '')) {
      this.loadPage(this.electionService.selectedPage);
    }
  }


  private doResize(): void {
    const wid = window.innerWidth;
    if (wid < 800) {
      this.cols = 1;
    }
    else {
      this.cols = 2;
    }
    this.bodyHeight = '' + (window.innerHeight - 110) + 'px';
  }


  private isDataLoaded(electionDateString: string): boolean {
    const election = this.electionService.electionMap.get(electionDateString);
    if (election) {
      return election.dataSourceTrigger([
        DataSourcesEnum.HAChange,
        DataSourcesEnum.HAStatic
      ]);
    }
    return false;
  }


  private loadPage(page: ISelectPage): void {
    this.lastUpdate = this.electionService.getLastUpdate(page.electionDateString ?? '', true);
    const election = this.electionService.electionMap.get(page.electionDateString ?? '');
    this.isFinal = election?.haChange?.electionStatus ? election?.haChange?.electionStatus === ElectionStatusEnum.final : true;
    if (this.isFinal) {
      this.headingTitle = 'House of Assembly Results \u2013 Final';
      this.disclaimer = 'The counting of votes for this election is now concluded. All votes have been counted and the results are final.';
      this.seatsTitle = 'Seats Won';
      this.leadingByDistrictTitle = 'Elected Members of the House of Assembly';
    } else {
      this.headingTitle = 'House of Assembly Results \u2013 Provisional';
      this.disclaimer = 'Please note, results are provisional. Results will be published progressively. The figures below may not include all votes.';
      this.seatsTitle = 'Parties Currently Leading'
      this.leadingByDistrictTitle = 'Candidates currently leading in districts';
    }

    this.electionService.updateSubTitle(page.electionDateString ?? '');
    // TODO
    // const testAdelaide = this.electionService.dataStore.getFirstPreferences('Adelaide');
    // console.log(testAdelaide);
    //  const testAll = this.electionService.dataStore.getFirstPreferences(null);
    // console.log(testAll);
  }

  private checkResize(): void {
    this.isMobile = this.deviceService.isMobile();
    this.electionService.isMobile = this.isMobile;
  }


  public ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
